<div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
    <button
        (click)="activeModal.dismiss('Cross click')"
        aria-label="Close"
        class="btn-close"
        type="button"
    ></button>
</div>
<div class="modal-body">
    <span [innerHtml]="message | bypassSecurity: 'html'"></span>
</div>
<div class="modal-footer">
    <button
        (click)="activeModal.dismiss('Cross click')"
        class="btn btn-outline-secondary"
        type="button"
    >
        No, cancel
    </button>
    <button
        (click)="activeModal.dismiss('Confirm Delete'); deleteCallback($event)"
        [class]="'btn ' + confirmButtonClass"
        type="button"
    >
        Yes, delete
    </button>
</div>
